/**
 * Google Maps Configuration Helper
 *
 * This file helps configure the Google Maps API key for the LocationPickerModal component.
 * Since the component is in a shared package (cb-front-end) and needs to work in both
 * main-frontend and admin-frontend, we use window object to access the API key.
 */

/**
 * Initialize Google Maps API key on window object
 * Call this in your application's main entry point (e.g., index.html or main.tsx)
 *
 * @param apiKey - Your Google Maps API key
 *
 * @example
 * // In main.tsx or index.tsx:
 * import { initGoogleMapsApiKey } from 'cb-front-end/location/googleMapsConfig';
 *
 * // Set the API key from environment variable
 * if (import.meta.env.VITE_GOOGLE_MAPS_API_KEY) {
 *   initGoogleMapsApiKey(import.meta.env.VITE_GOOGLE_MAPS_API_KEY);
 * }
 */
export function initGoogleMapsApiKey(apiKey: string): void {
  if (typeof window !== 'undefined') {
    (window as any).GOOGLE_MAPS_API_KEY = apiKey;
  }
}

/**
 * Get the Google Maps API key from window object
 *
 * @returns The API key or empty string if not set
 */
export function getGoogleMapsApiKey(): string {
  if (typeof window !== 'undefined' && (window as any).GOOGLE_MAPS_API_KEY) {
    return (window as any).GOOGLE_MAPS_API_KEY;
  }
  return '';
}
